import 'popper.js';
import 'bootstrap/util';
import 'bootstrap/dropdown';
import 'bootstrap/collapse';
import 'bootstrap/modal';
import 'bootstrap/tab';
import 'bootstrap/tooltip';
import 'bootstrap-3-typeahead';
import toast from 'izitoast';
// import cart from './ordering/_cart';
import './_prototypes/parsley';
import getUrlParameter from './_util/getUrlParameter';

/**
 * Sometimes Babel doesn't see promise usage in dependencies.
 * This will force the polyfill on every page.
 */
window.Promise = Promise;

/**
 * Toast shortcut functions
 */
(function () {
    window.toast = {
        success: (message, timeout = 5000) => {
            toast.success({
                title: 'Success',
                icon: 'fas fa-check-circle',
                displayMode: 2,
                message,
                timeout,
            });
        },
        successBanner: (message, timeout = 5000) => {
            toast.show({
                title: 'Success',
                icon: 'fas fa-check-circle',
                displayMode: 2,
                position: 'topCenter',
                layout: 2,
                message,
                backgroundColor: '#AFF1BF',
                timeout,
            });
        },
        error: (message, timeout = 5000) => {
            toast.error({
                title: 'Error',
                icon: 'fas fa-exclamation-circle',
                displayMode: 2,
                message,
                timeout,
            });
        },
        errorBanner: (message, timeout = 5000) => {
            toast.show({
                title: 'Error',
                icon: 'fas fa-exclamation-triangle',
                displayMode: 2,
                position: 'topCenter',
                layout: 2,
                message,
                backgroundColor: '#F7CCD0',
                timeout,
            });
        },
        warning: (message, timeout = 5000) => {
            toast.warning({
                title: 'Warning',
                icon: 'fas fa-exclamation-triangle',
                displayMode: 2,
                message,
                timeout,
            });
        },
        info: (message, timeout = 5000) => {
            toast.info({
                title: 'Information',
                icon: 'fas fa-info-circle',
                displayMode: 2,
                message,
                timeout,
            });
        },
    };
}());


/**
 * Global banners triggered by query strings
 */
(function () {
    // This is the source of the question in PR 460265896. Just changing these to only show a generic message for now.
    const errorMessage = getUrlParameter('error');
    const successMessage = getUrlParameter('success');
    if (errorMessage) window.toast.errorBanner('Request was unsuccessful');
    if (successMessage) window.toast.successBanner('Request was successful');
}());


/**
 * Need Help? modal
 */
(function () {

    const $form = $('#help__form');

    if ($form.length) {

        $form
            .parsley()
            .on('form:submit', function () {
                const $this = $(this.element);
                const formdata = $this.serializeArray().reduce((obj, member) => {
                    obj[member.name] = member.value;
                    return obj;
                }, {});
                const $tabPane = $this.parents('.tab-pane');
                const $submitBtn = $this.find('button[type="submit"]');
                const submitBtnHtml = $submitBtn.html();
                $submitBtn
                    .width($submitBtn.width())
                    .html('<i class="fas fa-spinner fa-pulse fa-fw"></i>')
                    .prop('disabled', true)
                    .attr('aria-disabled', true);
                $.post('./utility/help-message', formdata)
                    .done(() => {
                        $tabPane.html(`
                            <div class="text-center p-3">
                                <h5>Your message has been sent successfully. We will get back to you as soon as possible.</h5>
                                <a href="#" data-toggle="modal" data-target="#help__modal">Close this window</a>
                            </div>
                        `);
                    })
                    .fail(() => {
                        $tabPane.html(`
                            <div class="text-center p-3">
                                <span class="text-danger">An error has occurred. Please try again later.</span>
                            </div>
                        `);
                        $submitBtn
                            .prop('disabled', false)
                            .attr('aria-disabled', false)
                            .html(submitBtnHtml);
                    });
                return false;
            });

        $('#help__modal').on('shown.bs.modal', function () {
            $(this).find('input, textarea').first().focus();
        });
    }

}());


/**
 * Bootstrap sub-menu
 */
(function () {
    $('.dropdown-menu a.dropdown-toggle').on('click', function (e) {
        const $el = $(this);
        const $parent = $(this).offsetParent('.dropdown-menu');
        const isDropLeft = $parent.hasClass('dropleft');
        if (!$(this).next().hasClass('show')) {
            $(this)
                .parents('.dropdown-menu')
                .first()
                .find('.show')
                .removeClass('show');
        }
        const $subMenu = $(this).next('.dropdown-menu');
        const isShowingSubMenu = !$subMenu.hasClass('show');
        $subMenu
            .trigger(isShowingSubMenu ? 'show.bs.dropdown' : 'hide.bs.dropdown')
            .toggleClass('show')
            .trigger(isShowingSubMenu ? 'shown.bs.dropdown' : 'hidden.bs.dropdown');

        $(this).parent('li').toggleClass('show');

        $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function (e) {
            $('.dropdown-menu .show').removeClass('show');
        });

        if (!$parent.parent().hasClass('navbar-nav')) {
            $el.next().css({
                top: $el[0].offsetTop - 3,
                left: ($parent.outerWidth() - 3) * (isDropLeft ? -1 : 1),
            });
        }

        return false;
    });
}());


/**
 * Log in as... dropdown
 */
(function () {
    $('#log-in-as-dropdown').on('show.bs.dropdown', function () {
        const $dropdown = $(this).find('.dropdown-menu');
        const needsLoading = $dropdown.find('.dropdown-item').first().hasClass('needs-reload');
        const whereAmI = encodeURIComponent(`${location.pathname}${location.search}`);
        if (needsLoading) {
            $.get(`./utility/impersonation-list?returnTo=${whereAmI}`)
                .done(response => {
                    $dropdown.html(response);
                })
                .fail((xhr, stat, err) => toast.error(err));
        }
    });
}());


/**
 * Ordering site search bar autocomplete
 */
(function () {
    const $search = $('#search, #search-modal-input');
    function orderingSearchOnInput() {
        if ($(this).val().length === 0) return false;
        const $dropdown = $(this).next();
        if ($dropdown.is(':hidden')) {
            $dropdown.html('<li><div class="text-center"><i class="fas fa-spinner fa-pulse"></i></div></li>');
            $dropdown.show();
        }
    }

    $search.each(function () {
        $(this)
            .on('input', orderingSearchOnInput)
            .typeahead({
                delay: 500,
                menu: $(this).next(),
                source: function (search, process) {
                    if (!search) return [];
                    return $.get(`./utility/item-search-autocomplete?search=${encodeURIComponent(search)}`)
                        .done(response => {
                            if (response.success) {
                                return process(response.results);
                            }
                            return [];
                        });
                },
                afterSelect: function (item) {
                    if (item.id === 'NORESULTS') {
                        $search.val('');
                        return false;
                    }
                    location.href = `${$('base').attr('href')}ordering/items/${item.product}`;
                },
                addItem: {
                    id: 'NORESULTS',
                    name: 'No Results',
                },
            });
        $(this)
            .on('blur', function () {
                $(this).val('');
            });
    });

}());

/**
 * Ordering site cart dropdown
 */
(function () {
    $(document).on('click', '#shopping-cart .dropdown-menu', function (e) {
        const $target = $(e.target);

        // Prevent dropdown from closing when clicking inside of it
        e.stopPropagation();

        // Show spinner on button clicks
        if ($target.hasClass('btn')) {
            $target
                .width($target.width())
                .html('<i class="fas fa-spinner fa-pulse fa-fw"></i>');
        }

    //     // Remove from cart
    //     // // TODO
    //     // // - need to handle removing cart items on checkout page
    //     // // - need to handle deleting the item while still keeping the dropdown open
    //     if ($target.hasClass('cart-remove') || $target.parent().hasClass('cart-remove')) {
    //         e.preventDefault();
    //         const $parent = $target.parents('.list-group-item');
    //         const itemid = $parent.data('itemid');
    //         const versioningid = $parent.data('versioningid') || null;
    //         const eventid = $parent.data('eventid') || null;
    //         // const $spinner = $('#ordering-cart .cart-table-spinner');
    //         // const hideSpinner = setTimeout(() => $spinner.removeClass('d-none'), 200);
    //         cart.remove(itemid, {
    //             versioningid,
    //             eventid,
    //         })
    //             .then(() => {
    //                 if ($('#shopping-cart-table-container').length) cart.refreshTable();
    //             })
    //             .then(() => {
    //                 // clearTimeout(hideSpinner);
    //                 // $spinner.addClass('d-none');
    //             });
    //     }
    });
}());


/**
 * Impersonation bar dragging
 */
(function () {
    const $impersonationBar = $('#impersonation-bar');

    function dragElement(elmnt) {
        let pos1 = 0;
        let pos2 = 0;
        let left = 0;
        elmnt.onmousedown = dragMouseDown;
        const elementWidth = elmnt.clientWidth;
        const offset = elementWidth / 2;


        function dragMouseDown(e) {
            e = e || window.event;
            e.preventDefault();
            pos2 = e.clientX;
            document.onmouseup = closeDragElement;
            document.onmousemove = elementDrag;
        }

        function elementDrag(e) {
            e = e || window.event;
            e.preventDefault();
            pos1 = pos2 - e.clientX;
            pos2 = e.clientX;
            const newPosition = elmnt.offsetLeft - pos1;
            left = Math.min(Math.max(0 + offset, newPosition), window.innerWidth - offset);
            elmnt.style.left = `${left}px`;
        }

        function closeDragElement() {
            localStorage.setItem('__impersonationBarLeftPosition__', left);
            document.onmouseup = null;
            document.onmousemove = null;
        }
    }

    if ($impersonationBar.length && $impersonationBar.css('cursor') === 'move') {
        dragElement($impersonationBar.get(0));
        const leftPosition = localStorage.getItem('__impersonationBarLeftPosition__');
        if (leftPosition && +leftPosition && (window.innerWidth - $impersonationBar.width()) >= leftPosition) {
            $impersonationBar.css('left', `${leftPosition}px`);
        }
    }
}());


/**
 * User notifications
 */
(function () {

    function dismissNotifications(params) {
        $.post('./utility/notifications', params)
            .done(response => {
                if (response.success) {
                    $('.user-notification-badge, .user-notification-list-item-badge').text(response.notifications.length);
                }
            })
            .fail((xhr, stat, err) => {
                console.error(err);
                toast.error(err);
            });
    }

    $('#user-notification-dropdown').on('click', function () {
        $.get('./utility/notifications')
            .done(html => {
                $('#modal-container')
                    .html(html)
                    .find('.modal')
                    .on('show.bs.modal', function () {

                        $('.user-notification-dismiss-all')
                            .on('click', function () {
                                dismissNotifications(null);
                                $(this)
                                    .parent()
                                    .find('.list-group-item')
                                    .toggleClass('text-body text-black-50')
                                    .find('button')
                                    .remove();
                            });
                        $('.user-notification-dismiss')
                            .on('click', function () {
                                const notifid = $(this).parents('.list-group-item').data('notifid');
                                dismissNotifications({ notifid });
                                const $parent = $(this).parents('.list-group-item');
                                $parent.toggleClass('text-body text-black-50');
                                $(this).remove();
                            });
                    })
                    .modal();
            })
            .fail((xhr, stat, err) => {
                console.error(err);
                toast.error(err);
            });
    });
}());


$('[data-toggle="tooltip"]').tooltip();
